// React / Next
import { motion, Variants } from 'framer-motion';

// Standard SVG container variants (~15 paths)
const svgContainerVariants: Variants = {
  initial: { opacity: 1 },
  rest: {
    transition: {
      delayChildren: 0.2,
      staggerChildren: 0.015,
      staggerDirection: -1,
    },
  },
  hover: {
    transition: {
      staggerChildren: 0.015,
      staggerDirection: 1,
    },
  },
};

// Path animation variants (horizontal slide from right)
const svgPathVariantsHorizontal: Variants = {
  initial: { x: 150, opacity: 0 },
  rest: {
    x: 0,
    opacity: 1,
    transition: {
      duration: 0.5,
      ease: [0.34, 1.56, 0.64, 1],
    },
  },
  hover: {
    x: 150,
    opacity: 0,
    transition: { duration: 0.3, ease: 'easeIn' },
  },
};

/**
 * CDOsGraphic - Vertical bars pattern with horizontal animation
 * Paths slide in/out horizontally from the right
 */
export const CDOsGraphic = () => (
  <motion.svg
    viewBox="0 0 146 262"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="w-auto h-full block"
    variants={svgContainerVariants}
    aria-hidden="true"
  >
    <motion.g clipPath="url(#clip0_cdos)">
      <motion.path
        variants={svgPathVariantsHorizontal}
        d="M113.746 0H89.0107V286H113.746V0Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariantsHorizontal}
        d="M2.12182 106.826H0V180.103H2.12182V106.826Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariantsHorizontal}
        d="M27.7244 35.0938H23.3284V251.782H27.7244V35.0938Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariantsHorizontal}
        d="M26.1538 0H24.8877V286H26.1538V0Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariantsHorizontal}
        d="M33.2456 106.826H17.7949V180.103H33.2456V106.826Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariantsHorizontal}
        d="M62.0484 35.0938H40.7012V251.782H62.0484V35.0938Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariantsHorizontal}
        d="M56.2461 0H45.6604V286H56.2461V0Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariantsHorizontal}
        d="M91.2857 35.0938H69.9385V251.782H91.2857V35.0938Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariantsHorizontal}
        d="M87.1706 0H64.7214V286H87.1706V0Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariantsHorizontal}
        d="M68.4263 106.826H38.5684V180.103H68.4263V106.826Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariantsHorizontal}
        d="M141.952 251.781H163.299L163.299 35.0937H141.952L141.952 251.781Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariantsHorizontal}
        d="M112.715 251.781H134.062L134.063 35.0937H112.715L112.715 251.781Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariantsHorizontal}
        d="M116.83 286H139.279L139.279 0.000244141H116.83L116.83 286Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariantsHorizontal}
        d="M135.586 180.103H165.444V106.826H135.586V180.103Z"
        fill="#022E40"
      />
    </motion.g>
    <defs>
      <clipPath id="clip0_cdos">
        <rect width="204" height="286" fill="white" />
      </clipPath>
    </defs>
  </motion.svg>
);

